/** Shared inline SVG icons used across the UI so the same concept reads the
 *  same everywhere it appears. */

import imageRaw from "../icons/image.svg?raw";
import { stripIconSvg } from "../icons/stripIconSvg";

/** Photo / reference-image icon — a framed rectangle with a sun and a
 *  mountain range. Used on the Construction subtoolbar's "add reference
 *  image" button and the Layers panel's tracing-image rows so the toolbar
 *  affordance and the layer entry are recognisably the same thing (#545).
 *
 *  The glyph is `src/icons/image.svg`, read through the shared
 *  {@link stripIconSvg} (#216): no size of its own, so the host element's CSS
 *  controls it, and paint in `style` so a container's
 *  `svg { fill: currentColor }` can't fill the outline solid. */
export const IMAGE_ICON_SVG = stripIconSvg(imageRaw);
